var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "form",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            _c("div", { staticClass: "container-fluid" }, [
              _c(
                "form",
                {
                  staticClass: "form-horizontal col-sm-12",
                  attrs: { name: "vm.campaignBasicDetailsForm" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return handleSubmit(_vm.onSubmit)
                    }
                  }
                },
                [
                  _c("Field", {
                    attrs: {
                      label: _vm.$t("CAMPAIGN_CREATE_FORM_NAME_LABEL"),
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t("CAMPAIGN_CREATE_FORM_NAME_TT")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c("ValidationProvider", {
                                ref: "campaign_name",
                                attrs: { rules: "required", slim: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ classes }) {
                                        return [
                                          _c("div", { class: classes }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-sm-5 col-md-4"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.campaignName,
                                                      expression: "campaignName"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    id: "campaignNameInput",
                                                    type: "text",
                                                    name: "campaign_name",
                                                    autocomplete: "off",
                                                    placeholder: _vm.$t(
                                                      "CAMPAIGN_CREATE_FORM_NAME_PH"
                                                    )
                                                  },
                                                  domProps: {
                                                    value: _vm.campaignName
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.campaignName =
                                                        $event.target.value
                                                    }
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("label", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value: "REQUIRED",
                                                  expression: "'REQUIRED'"
                                                }
                                              ],
                                              staticClass:
                                                "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                            })
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _vm._v(" "),
                  _c("Field", {
                    attrs: {
                      label: _vm.$t("CAMPAIGN_CREATE_FORM_COUNTRY_LABEL"),
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t("CAMPAIGN_CREATE_FORM_COUNTRY_TT")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c("ValidationProvider", {
                                ref: "country",
                                attrs: { rules: "required", slim: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ classes }) {
                                        return [
                                          _c("div", { class: classes }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-sm-5 col-md-4"
                                              },
                                              [
                                                _c("input", {
                                                  attrs: {
                                                    id: "country",
                                                    type: "hidden",
                                                    name: "country"
                                                  },
                                                  domProps: {
                                                    value: _vm.countryName
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("CountrySelector", {
                                                  attrs: {
                                                    placeholder: _vm.$t(
                                                      "CAMPAIGN_CREATE_FORM_COUNTRY_DEFAULT"
                                                    ),
                                                    name: "country_selector"
                                                  },
                                                  model: {
                                                    value: _vm.countryValue,
                                                    callback: function($$v) {
                                                      _vm.countryValue = $$v
                                                    },
                                                    expression: "countryValue"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm.isContactSupport
                                                  ? _c("div", {
                                                      directives: [
                                                        {
                                                          name: "t",
                                                          rawName: "v-t",
                                                          value:
                                                            "CAMPAIGN_CREATE_SUPPORT_MESSAGE",
                                                          expression:
                                                            "'CAMPAIGN_CREATE_SUPPORT_MESSAGE'"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "bs-callout bs-callout-sm bs-callout-warning"
                                                    })
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("label", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value: "REQUIRED",
                                                  expression: "'REQUIRED'"
                                                }
                                              ],
                                              staticClass:
                                                "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                            })
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3"
                      },
                      [
                        _c(
                          "PrimaryButton",
                          {
                            attrs: {
                              size: "sm",
                              "show-loader-on-form": _vm.showLoader
                            }
                          },
                          [
                            _c("span", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "CREATE",
                                  expression: "'CREATE'"
                                }
                              ]
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("button", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CANCEL",
                              expression: "'CANCEL'"
                            }
                          ],
                          staticClass: "btn btn-sm btn-danger m-l-15",
                          on: { click: _vm.cancel }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }